<template>
  <div class="fee-template main-container">
    <loading :isShow="loading" />
    <div class="top-box">
      <div class="title-text">{{ query.mechanName }}—{{ query.productName }}</div>
      <div class="activity-name">版本号：{{ data.versionNo }}</div>
      <div class="activity-time">生效时间：{{ data.versionTime }}</div>
      <Button type="primary" ghost @click="backPage">返回</Button>
    </div>
    <rate-table ref="rateTable" :isEditAuth="false" :data="data" mode="base" :pageType="query.pageType" :type="query.nodeType"></rate-table>
  </div>
</template>
  
<script>
import rateTable from '@/components/commons/feeTemplate/rateTable';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  components: { rateTable },
  props: {},
  data() {
    return {
      tabId: '1',
      loading: false,
      data: [],
      query: {},
      detaile: {}
    };
  },
  activated() {
    this.query = this.$route.query;
    this.getData();
  },
  methods: {
    // 获取费率数据
    getData() {
      this.$http({
        url: '/buz/commission/productRateDetailSnapShotDetail',
        type: 'get',
        data: {
          organizationId: this.query.id,
          snapShotId: this.query.snapShotId,
          productCode: this.query.productCode
        }
      }).then(res => {
        if (res.data) {
          this.data = res.data;
        }
      });
    },
    backPage() {
      this.back();
    }
  }
};
</script>
<style lang="scss">
@import './rateDetail.scss';
</style>  